import { message as $message } from 'antd'

/**
 * 包装请求方法直接返回data
 */
export const wrapResponseData = async (request, config) => {
    try {
        const { success, message, data } = await request()

        if (success) {
            return data
        }

        $message.error(message)

        if (config?.rejection) {
            return Promise.reject(new Error(message))
        }
    } catch (e) {
        console.error(e)

        if (config?.rejection) {
            return Promise.reject(e)
        }
    }
}
